var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('bank-accounts',{attrs:{"customer":_vm.customer,"accounts":_vm.customer.bankaccounts}})],1),_c('v-col',{attrs:{"cols":"12","md":"6"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }